import axios from "axios";

const businessTermsExploreUrl = `/api/v1/business_terms_explore`;

const fetchCdes = (id, page = 1, per_page = 10, search = "") =>
  axios.get(`${businessTermsExploreUrl}/${id}/cde_definitions`, {
    params: { page, per_page, search },
  });

const associateCdes = (id, payload) =>
  axios.post(`${businessTermsExploreUrl}/${id}/cde_definitions/associate`, {
    cde_definition: payload,
  });

const fetchDomains = (id, page = 1, per_page = 10, search = "") =>
  axios.get(`${businessTermsExploreUrl}/${id}/domains`, {
    params: { page, per_page, search },
  });

const associateDomains = (id, payload) =>
  axios.post(`${businessTermsExploreUrl}/${id}/domains/associate`, {
    domain: payload,
  });

const fetchDataSources = (id, page = 1, per_page = 10, search = "") =>
  axios.get(`${businessTermsExploreUrl}/${id}/data_sources`, {
    params: { page, per_page, search },
  });

const associateDataSources = (id, payload) =>
  axios.post(`${businessTermsExploreUrl}/${id}/data_sources/associate`, {
    data_source: payload,
  });

const fetchReferenceSources = (id, page = 1, per_page = 10, search = "") =>
  axios.get(`${businessTermsExploreUrl}/${id}/reference_sources`, {
    params: { page, per_page, search },
  });

const associateReferenceSources = (id, payload) =>
  axios.post(`${businessTermsExploreUrl}/${id}/reference_sources/associate`, {
    reference_source: payload,
  });

const businessTermsExploreApi = {
  fetchCdes,
  associateCdes,
  fetchDomains,
  associateDomains,
  fetchDataSources,
  associateDataSources,
  fetchReferenceSources,
  associateReferenceSources,
};

export default businessTermsExploreApi;
